import React, { Component } from "react";
import commonUtil from "../../../../../../../utils/commonUtil";
 
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { clearEventData } from "../../../../../../createEvent/actions";
import { setSelectedImage1, setSelectedImage2, setEventTxtValue, setEventDateValue, setEventComment, setThemeData, setSelectedThemeUid } from "../../../../../../createEvent/components/createEvent/actions";

const channel = commonUtil.getChannel();

const applicationRoutes = commonUtil.getApplicationRoutes();

class CreateTableModalOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isactiveItem: null,
      title: "Selecciona el tipo de mesa",
      step1: true,
      route: "/",
    };
  }

  initialJson = {
    giftList: {
      items: [
        {
          id: 1,
          name: "Mesa de bebé",
          tabName: "mesa-de-bebe",
          label: "Bebe",
          image: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
            <path d="M8 6.49995H0.003125C0.084375 4.18432 1.29062 2.15307 3.09375 0.940574C3.50938 0.662449 4.05625 0.806199 4.34062 1.21557L8 6.49995ZM12 5.49995C12 4.39682 12.8969 3.49995 14 3.49995H15C15.5531 3.49995 16 3.94682 16 4.49995C16 5.05307 15.5531 5.49995 15 5.49995H14V7.49995C14 8.28745 13.8188 9.0687 13.4688 9.79682C13.1187 10.5249 12.6 11.1874 11.95 11.7437C11.3 12.2999 10.5281 12.7437 9.67813 13.0437C8.82812 13.3437 7.91875 13.4999 7 13.4999C6.08125 13.4999 5.17188 13.3437 4.32188 13.0437C3.47188 12.7437 2.7 12.2999 2.05 11.7437C1.4 11.1874 0.884375 10.5249 0.53125 9.79682C0.178125 9.0687 0 8.28745 0 7.49995H12V5.49995ZM2.5 13.4999C2.89782 13.4999 3.27936 13.658 3.56066 13.9393C3.84196 14.2206 4 14.6021 4 14.9999C4 15.3978 3.84196 15.7793 3.56066 16.0606C3.27936 16.3419 2.89782 16.4999 2.5 16.4999C2.10218 16.4999 1.72064 16.3419 1.43934 16.0606C1.15804 15.7793 1 15.3978 1 14.9999C1 14.6021 1.15804 14.2206 1.43934 13.9393C1.72064 13.658 2.10218 13.4999 2.5 13.4999ZM10 14.9999C10 14.6021 10.158 14.2206 10.4393 13.9393C10.7206 13.658 11.1022 13.4999 11.5 13.4999C11.8978 13.4999 12.2794 13.658 12.5607 13.9393C12.842 14.2206 13 14.6021 13 14.9999C13 15.3978 12.842 15.7793 12.5607 16.0606C12.2794 16.3419 11.8978 16.4999 11.5 16.4999C11.1022 16.4999 10.7206 16.3419 10.4393 16.0606C10.158 15.7793 10 15.3978 10 14.9999Z"  />
          </svg>`,
          route: applicationRoutes.createBaby,
          eventType: 'Bebé',
        },
        {
          id: 2,
          name: "Mesa de boda",
          tabName: "mesa-de-boda",
          label: "Boda",
          image: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
            <path d="M7.99996 14.5C7.91222 14.5005 7.82524 14.4837 7.74402 14.4505C7.66279 14.4173 7.58892 14.3685 7.52662 14.3067L2.34662 9.12001C1.69686 8.46346 1.3324 7.57706 1.3324 6.65334C1.3324 5.72963 1.69686 4.84323 2.34662 4.18668C3.00146 3.53369 3.88851 3.16699 4.81329 3.16699C5.73807 3.16699 6.62511 3.53369 7.27996 4.18668L7.99996 4.90668L8.71995 4.18668C9.3748 3.53369 10.2618 3.16699 11.1866 3.16699C12.1114 3.16699 12.9984 3.53369 13.6533 4.18668C14.303 4.84323 14.6675 5.72963 14.6675 6.65334C14.6675 7.57706 14.303 8.46346 13.6533 9.12001L8.47329 14.3067C8.411 14.3685 8.33712 14.4173 8.25589 14.4505C8.17467 14.4837 8.08769 14.5005 7.99996 14.5Z"  />
          </svg>`
          ,
          route: applicationRoutes.createWedding,
          eventType: 'Boda',
        },
        {
          id: 3,
          name: "Mesa de XV años",
          tabName: "mesa-de-xv-anos",
          label: "XV anos",
          image: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
            <path d="M9.33339 3.83357C9.33339 4.18691 9.19606 4.50824 8.97139 4.74691L10.7207 6.93357C10.7445 6.96341 10.7778 6.9842 10.815 6.99245C10.8523 7.0007 10.8912 6.99592 10.9254 6.97891L12.6921 6.09491C12.6539 5.90149 12.659 5.70202 12.707 5.51081C12.755 5.3196 12.8448 5.14139 12.9698 4.98896C13.0948 4.83653 13.2521 4.71366 13.4302 4.62917C13.6083 4.54467 13.8029 4.50064 14.0001 4.50024C14.3278 4.50031 14.6441 4.62112 14.8885 4.83959C15.1328 5.05807 15.2882 5.3589 15.3248 5.68464C15.3614 6.01037 15.2767 6.33818 15.087 6.60545C14.8972 6.87273 14.6157 7.06074 14.2961 7.13357L13.0934 13.5489C13.0432 13.8163 12.9011 14.0577 12.6917 14.2315C12.4823 14.4052 12.2188 14.5002 11.9467 14.5002H4.05339C3.78132 14.5002 3.51781 14.4052 3.30842 14.2315C3.09903 14.0577 2.95694 13.8163 2.90673 13.5489L1.70406 7.13357C1.44847 7.0753 1.21572 6.94297 1.03493 6.75314C0.854135 6.5633 0.733313 6.32438 0.68757 6.06625C0.641827 5.80812 0.673192 5.54224 0.777744 5.30184C0.882296 5.06144 1.0554 4.85719 1.2754 4.71463C1.4954 4.57208 1.75255 4.49754 2.01469 4.50034C2.27682 4.50314 2.53232 4.58315 2.74923 4.73037C2.96614 4.87759 3.13484 5.08549 3.23423 5.32807C3.33362 5.57065 3.3593 5.83715 3.30806 6.09424L5.07473 6.97824C5.10888 6.99525 5.14783 7.00003 5.18508 6.99178C5.22233 6.98353 5.25562 6.96275 5.27939 6.93291L7.02873 4.74624C6.87968 4.58774 6.77169 4.39518 6.71417 4.18536C6.65665 3.97553 6.65135 3.75482 6.69873 3.54248C6.74611 3.33013 6.84473 3.13261 6.98599 2.96714C7.12725 2.80167 7.30686 2.67328 7.50914 2.59318C7.71142 2.51307 7.93023 2.48368 8.14648 2.50758C8.36273 2.53147 8.56985 2.60792 8.74977 2.73025C8.92968 2.85258 9.07693 3.01708 9.17866 3.2094C9.28039 3.40172 9.33351 3.61601 9.33339 3.83357ZM8.00006 11.8336C8.35368 11.8336 8.69282 11.6931 8.94287 11.443C9.19292 11.193 9.33339 10.8539 9.33339 10.5002C9.33339 10.1466 9.19292 9.80748 8.94287 9.55743C8.69282 9.30738 8.35368 9.16691 8.00006 9.16691C7.64644 9.16691 7.3073 9.30738 7.05725 9.55743C6.8072 9.80748 6.66673 10.1466 6.66673 10.5002C6.66673 10.8539 6.8072 11.193 7.05725 11.443C7.3073 11.6931 7.64644 11.8336 8.00006 11.8336Z"  />
          </svg>`,
          route: applicationRoutes.createXVYears,
          eventType: 'XV años',
        },
        {
          id: 4,
          name: "Mesa de Bautizo",
          tabName: "mesa-de-bautizo",
          label: "Bautizo",
          image: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
                 <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99998 2.1001C8.21215 2.1001 8.41563 2.18438 8.56566 2.33441C8.71569 2.48444 8.79998 2.68792 8.79998 2.9001V3.7001C8.79998 3.91227 8.71569 4.11575 8.56566 4.26578C8.41563 4.41581 8.21215 4.5001 7.99998 4.5001C7.7878 4.5001 7.58432 4.41581 7.43429 4.26578C7.28426 4.11575 7.19998 3.91227 7.19998 3.7001V2.9001C7.19998 2.68792 7.28426 2.48444 7.43429 2.33441C7.58432 2.18438 7.7878 2.1001 7.99998 2.1001ZM11.2 8.5001C11.2 9.34879 10.8628 10.1627 10.2627 10.7628C9.6626 11.363 8.84867 11.7001 7.99998 11.7001C7.15128 11.7001 6.33735 11.363 5.73723 10.7628C5.13712 10.1627 4.79998 9.34879 4.79998 8.5001C4.79998 7.6514 5.13712 6.83747 5.73723 6.23736C6.33735 5.63724 7.15128 5.3001 7.99998 5.3001C8.84867 5.3001 9.6626 5.63724 10.2627 6.23736C10.8628 6.83747 11.2 7.6514 11.2 8.5001ZM10.8288 12.4601L11.3944 13.0257C11.5453 13.1714 11.7473 13.2521 11.9571 13.2502C12.1669 13.2484 12.3675 13.1643 12.5158 13.016C12.6642 12.8676 12.7483 12.667 12.7501 12.4572C12.7519 12.2475 12.6713 12.0454 12.5256 11.8945L11.96 11.3289C11.8091 11.1832 11.607 11.1025 11.3973 11.1044C11.1875 11.1062 10.9868 11.1903 10.8385 11.3386C10.6902 11.487 10.6061 11.6876 10.6042 11.8974C10.6024 12.1071 10.683 12.3092 10.8288 12.4601ZM12.5248 3.9745C12.6748 4.12452 12.759 4.32797 12.759 4.5401C12.759 4.75223 12.6748 4.95568 12.5248 5.1057L11.96 5.6713C11.8862 5.74771 11.7979 5.80865 11.7003 5.85058C11.6027 5.89251 11.4977 5.91457 11.3915 5.9155C11.2853 5.91642 11.1799 5.89618 11.0816 5.85595C10.9833 5.81573 10.894 5.75633 10.8189 5.68121C10.7437 5.6061 10.6843 5.51678 10.6441 5.41846C10.6039 5.32014 10.5837 5.2148 10.5846 5.10858C10.5855 5.00235 10.6076 4.89738 10.6495 4.79977C10.6914 4.70217 10.7524 4.6139 10.8288 4.5401L11.3944 3.9745C11.5444 3.82452 11.7478 3.74027 11.96 3.74027C12.1721 3.74027 12.3748 3.82452 12.5248 3.9745ZM13.6 9.3001C13.8121 9.3001 14.0156 9.21581 14.1657 9.06578C14.3157 8.91575 14.4 8.71227 14.4 8.5001C14.4 8.28792 14.3157 8.08444 14.1657 7.93441C14.0156 7.78438 13.8121 7.7001 13.6 7.7001H12.8C12.5878 7.7001 12.3843 7.78438 12.2343 7.93441C12.0843 8.08444 12 8.28792 12 8.5001C12 8.71227 12.0843 8.91575 12.2343 9.06578C12.3843 9.21581 12.5878 9.3001 12.8 9.3001H13.6ZM7.99998 12.5001C8.21215 12.5001 8.41563 12.5844 8.56566 12.7344C8.71569 12.8844 8.79998 13.0879 8.79998 13.3001V14.1001C8.79998 14.3123 8.71569 14.5158 8.56566 14.6658C8.41563 14.8158 8.21215 14.9001 7.99998 14.9001C7.7878 14.9001 7.58432 14.8158 7.43429 14.6658C7.28426 14.5158 7.19998 14.3123 7.19998 14.1001V13.3001C7.19998 13.0879 7.28426 12.8844 7.43429 12.7344C7.58432 12.5844 7.7878 12.5001 7.99998 12.5001ZM4.03998 5.6713C4.11425 5.74563 4.20244 5.8046 4.29951 5.84484C4.39657 5.88509 4.50061 5.90582 4.60569 5.90586C4.71077 5.9059 4.81483 5.88524 4.91192 5.84506C5.00902 5.80488 5.09725 5.74597 5.17158 5.6717C5.2459 5.59742 5.30487 5.50923 5.34512 5.41217C5.38537 5.3151 5.4061 5.21106 5.40614 5.10598C5.40617 5.0009 5.38551 4.89684 5.34534 4.79975C5.30516 4.70266 5.24625 4.61443 5.17198 4.5401L4.60558 3.9745C4.45469 3.82877 4.25261 3.74814 4.04285 3.74996C3.8331 3.75178 3.63245 3.83592 3.48412 3.98424C3.33579 4.13257 3.25166 4.33322 3.24984 4.54298C3.24801 4.75273 3.32865 4.95482 3.47438 5.1057L4.03998 5.6713ZM5.17118 12.4601L4.60558 13.0257C4.45469 13.1714 4.25261 13.2521 4.04285 13.2502C3.8331 13.2484 3.63245 13.1643 3.48412 13.016C3.33579 12.8676 3.25166 12.667 3.24984 12.4572C3.24801 12.2475 3.32865 12.0454 3.47438 11.8945L4.03998 11.3289C4.19086 11.1832 4.39294 11.1025 4.6027 11.1044C4.81245 11.1062 5.0131 11.1903 5.16143 11.3386C5.30976 11.487 5.39389 11.6876 5.39571 11.8974C5.39754 12.1071 5.3169 12.3092 5.17118 12.4601ZM3.19998 9.3001C3.41215 9.3001 3.61563 9.21581 3.76566 9.06578C3.91569 8.91575 3.99998 8.71227 3.99998 8.5001C3.99998 8.28792 3.91569 8.08444 3.76566 7.93441C3.61563 7.78438 3.41215 7.7001 3.19998 7.7001H2.39998C2.1878 7.7001 1.98432 7.78438 1.83429 7.93441C1.68426 8.08444 1.59998 8.28792 1.59998 8.5001C1.59998 8.71227 1.68426 8.91575 1.83429 9.06578C1.98432 9.21581 2.1878 9.3001 2.39998 9.3001H3.19998Z"/>
                 </svg>`,
          route: applicationRoutes.createBaptisms,
          eventType: 'Bautizo',
        },
        {
          id: 5,
          name: "Mesa de Cumpleaños",
          tabName: "mesa-de-cumpleanos",
          label: "Cumpleanos",
          image: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
            <path d="M8.45333 4.41998C8.92 4.25998 9.26667 3.81998 9.32 3.32664C9.35333 3.01331 9.28667 2.71998 9.13333 2.47998L8.28 0.999975C8.25012 0.949687 8.20767 0.908033 8.15683 0.879103C8.10599 0.850173 8.0485 0.834961 7.99 0.834961C7.9315 0.834961 7.87401 0.850173 7.82317 0.879103C7.77233 0.908033 7.72988 0.949687 7.7 0.999975L6.84667 2.47998C6.73333 2.67998 6.66667 2.91331 6.66667 3.16664C6.66667 4.04664 7.53333 4.73331 8.45333 4.41998ZM11.02 11.1133L10.3533 10.4466L9.63333 11.16C8.76667 12.0266 7.24667 12.0333 6.37333 11.16L5.66 10.4466L4.93333 11.16C4.5 11.5933 3.92 11.8333 3.30667 11.8333C2.82 11.8333 2.37333 11.68 2 11.4266V13.8333C2 14.5666 2.6 15.1666 3.33333 15.1666H12.6667C13.4 15.1666 14 14.5666 14 13.8333V11.4266C13.5 11.7666 12.86 11.9266 12.1733 11.7733C11.7333 11.68 11.34 11.4333 11.02 11.1133ZM12 6.49997H8.66667V5.83331C8.66667 5.46664 8.36667 5.16664 8 5.16664C7.63333 5.16664 7.33333 5.46664 7.33333 5.83331V6.49997H4C2.89333 6.49997 2 7.39331 2 8.49997V9.47331C2 10.04 2.33333 10.5866 2.87333 10.7666C3.36 10.9266 3.88667 10.8066 4.22667 10.46L5.65333 9.03998L7.07333 10.46C7.58 10.9666 8.41333 10.9666 8.92 10.46L10.3467 9.03998L11.7667 10.46C12.0533 10.7466 12.4533 10.88 12.8667 10.8266C13.5267 10.74 13.9933 10.12 13.9933 9.45331V8.50664C13.9957 8.24358 13.9459 7.98266 13.8467 7.739C13.7476 7.49534 13.601 7.27377 13.4156 7.08713C13.2302 6.90049 13.0096 6.7525 12.7666 6.65171C12.5236 6.55092 12.2631 6.49935 12 6.49997Z"  />
          </svg>`,
          route: applicationRoutes.createBirthday,
          eventType: 'Cumpleaños'
        },
        {
          id: 6,
          name: "Mesa de Open house",
          tabName: "mesa-de-open-house",
          label: "Open House",
          image: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
            <path d="M5.59998 6.5001C5.59998 4.0393 7.53918 2.1001 9.99998 2.1001C12.4608 2.1001 14.4 4.0393 14.4 6.5001C14.4 8.9609 12.4608 10.9001 9.99998 10.9001C9.59541 10.9046 9.19199 10.8562 8.79998 10.7561V10.9001C8.79998 11.1123 8.71569 11.3158 8.56566 11.4658C8.41563 11.6158 8.21215 11.7001 7.99998 11.7001H7.19998V12.5001C7.19998 12.7123 7.11569 12.9158 6.96566 13.0658C6.81563 13.2158 6.61215 13.3001 6.39998 13.3001H5.59998V13.7001C5.59998 14.0184 5.47355 14.3236 5.2485 14.5486C5.02346 14.7737 4.71824 14.9001 4.39998 14.9001H2.79998C2.48172 14.9001 2.17649 14.7737 1.95145 14.5486C1.7264 14.3236 1.59998 14.0184 1.59998 13.7001V12.4313C1.59998 12.1129 1.72638 11.8073 1.95198 11.5833L5.58398 7.9505C5.69118 7.8433 5.74398 7.6561 5.69758 7.4401C5.63199 7.13108 5.59928 6.816 5.59998 6.5001ZM12 5.3001C12 5.08792 11.9157 4.88444 11.7657 4.73441C11.6156 4.58438 11.4121 4.5001 11.2 4.5001C10.9878 4.5001 10.7843 4.58438 10.6343 4.73441C10.4843 4.88444 10.4 5.08792 10.4 5.3001C10.4 5.51227 10.4843 5.71575 10.6343 5.86578C10.7843 6.01581 10.9878 6.1001 11.2 6.1001C11.4121 6.1001 11.6156 6.01581 11.7657 5.86578C11.9157 5.71575 12 5.51227 12 5.3001Z"  />
          </svg>`,
          route: applicationRoutes.createOpenHouse,
          eventType: 'Open House',
        },
        {
          id: 7,
          name: "Mesa de mascota",
          tabName: "mesa-de-mascota",
          label: "Mascotas",
          image: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
            <path d="M5.56665 2.49977C6.35331 2.38644 7.18665 3.24644 7.42664 4.43311C7.66665 5.61311 7.23331 6.66644 6.44664 6.78644C5.66665 6.90644 4.82664 6.04644 4.57998 4.85977C4.33331 3.67977 4.77998 2.62644 5.56665 2.49977ZM10.3333 2.49977C11.1266 2.62644 11.5666 3.67977 11.3333 4.85977C11.08 6.04644 10.2466 6.90644 9.45998 6.78644C8.66664 6.66644 8.23331 5.61311 8.47998 4.43311C8.71998 3.24644 9.55331 2.38644 10.3333 2.49977ZM1.99998 5.56644C2.75998 5.23977 3.79331 5.83311 4.33331 6.86644C4.83998 7.91978 4.66664 9.02644 3.91331 9.35311C3.15998 9.67977 2.13331 9.09311 1.60665 8.04644C1.07998 6.99977 1.26664 5.88644 1.99998 5.56644ZM14 5.56644C14.7333 5.88644 14.92 6.99977 14.3933 8.04644C13.8666 9.09311 12.84 9.67977 12.0866 9.35311C11.3333 9.02644 11.16 7.91978 11.6666 6.86644C12.2066 5.83311 13.24 5.23977 14 5.56644ZM12.8866 12.7531C12.9133 13.3798 12.4333 14.0731 11.86 14.3331C10.6666 14.8798 9.25331 13.7464 7.92664 13.7464C6.59998 13.7464 5.17331 14.9264 3.99998 14.3331C3.33331 14.0064 2.87331 13.1398 2.95998 12.4198C3.07998 11.4264 4.27331 10.8931 4.97998 10.1664C5.91998 9.22644 6.58665 7.45977 7.92664 7.45977C9.25998 7.45977 9.96664 9.19978 10.8666 10.1664C11.6066 10.9798 12.84 11.6664 12.8866 12.7531Z"  />
          </svg>`,
          route: applicationRoutes.createMascotas,
          eventType: 'Mascotas',
        },
        {
          id: 8,
          name: "Mesa de ceremonias religiosas",
          tabName: "mesa-de-ceremonias-religiosas",
          label: "Otras Ceremonias Religiosas",
          image: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
            <path d="M9.61759 6.11242H6.38239C5.74079 6.11242 5.21875 6.63445 5.21875 7.27605V14.6769C5.21875 15.3185 5.74079 15.8406 6.38239 15.8406H9.61759C10.2592 15.8406 10.7812 15.3185 10.7812 14.6769V7.27605C10.7812 6.63445 10.2592 6.11242 9.61759 6.11242ZM7.99999 5.89467C9.00813 5.89467 9.8282 5.07445 9.8282 4.06645C9.8282 3.65729 9.69584 3.27053 9.44537 2.94776C9.35199 2.82747 9.1821 2.7994 9.05511 2.88347C9.00173 2.91867 8.94471 2.9498 8.88711 2.977C8.90559 2.8666 8.91257 2.75315 8.90762 2.63693C8.90733 2.62762 8.90646 2.61816 8.905 2.60885C8.83635 2.11765 8.64769 1.47358 8.13977 1.19504C8.02631 1.13293 7.88566 1.15285 7.79417 1.24435C7.71519 1.32333 7.6893 1.43925 7.72406 1.54253C7.7213 1.59358 7.67082 1.92304 6.87402 2.62805C6.81482 2.67431 6.76362 2.71882 6.71795 2.76376C6.71533 2.76609 6.713 2.76842 6.71111 2.77031C6.36319 3.1162 6.17162 3.57656 6.17162 4.06675C6.17177 5.0746 6.99184 5.89467 7.99999 5.89467Z" />
          </svg>`,
          route: applicationRoutes.createReligious,
          eventType: 'Otras Ceremonias Religiosas',
        },
        {
          id: 9,
          name: "Mesa de otros eventos",
          tabName: "mesa-de-otros-eventos",
          label: "Otros",
          image: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
            <path d="M3.09338 10.6802V13.8935C3.09514 14.055 3.16053 14.2093 3.27537 14.3229C3.3902 14.4365 3.5452 14.5002 3.70672 14.5002H7.45338V10.6802H3.09338Z" />
            <path d="M8.54663 14.5002H12.2933C12.4548 14.5002 12.6098 14.4365 12.7247 14.3229C12.8395 14.2093 12.9049 14.055 12.9066 13.8935V10.6802H8.54663V14.5002Z"  />
            <path d="M13.4 5.22667H12.1733C12.299 4.97148 12.3651 4.69111 12.3667 4.40667C12.3649 3.90038 12.1625 3.41542 11.8039 3.05804C11.4453 2.70066 10.9596 2.5 10.4533 2.5C9.92443 2.52508 9.4134 2.69927 8.97929 3.00244C8.54517 3.30562 8.20567 3.72541 8 4.21333C7.79433 3.72541 7.45483 3.30562 7.02071 3.00244C6.5866 2.69927 6.07557 2.52508 5.54667 2.5C5.04037 2.5 4.55472 2.70066 4.19609 3.05804C3.83746 3.41542 3.6351 3.90038 3.63333 4.40667C3.63491 4.69111 3.70102 4.97148 3.82667 5.22667H2.6C2.26667 5.22667 2 5.62 2 6.1V8.72C2 9.2 2.26667 9.59333 2.6 9.59333H7.45333V5.22667H8.54667V9.59333H13.4C13.7333 9.59333 14 9.2 14 8.72V6.1C14 5.62 13.7333 5.22667 13.4 5.22667ZM5.54667 5.22667C5.43322 5.23693 5.31888 5.22344 5.21093 5.18706C5.10299 5.15068 5.0038 5.09221 4.91971 5.01538C4.83561 4.93854 4.76845 4.84503 4.72249 4.7408C4.67654 4.63657 4.65281 4.52391 4.65281 4.41C4.65281 4.29609 4.67654 4.18343 4.72249 4.0792C4.76845 3.97497 4.83561 3.88146 4.91971 3.80462C5.0038 3.72779 5.10299 3.66932 5.21093 3.63294C5.31888 3.59656 5.43322 3.58307 5.54667 3.59333C6.48 3.59333 7.00667 4.55333 7.26667 5.22667H5.54667ZM10.4533 5.22667H8.73333C8.99333 4.56 9.52 3.59333 10.4533 3.59333C10.5668 3.58307 10.6811 3.59656 10.7891 3.63294C10.897 3.66932 10.9962 3.72779 11.0803 3.80462C11.1644 3.88146 11.2316 3.97497 11.2775 4.0792C11.3235 4.18343 11.3472 4.29609 11.3472 4.41C11.3472 4.52391 11.3235 4.63657 11.2775 4.7408C11.2316 4.84503 11.1644 4.93854 11.0803 5.01538C10.9962 5.09221 10.897 5.15068 10.7891 5.18706C10.6811 5.22344 10.5668 5.23693 10.4533 5.22667Z" />
          </svg>`,
          route: applicationRoutes.createOtras,
          eventType: 'Otros',
        },
      ],
    },
  };

  mesaDeRegalos = [
    "Crea tu Mesa de Regalos desde doce meses antes del evento sin costo desde liverpool.com.mx, a través de tu celular o en tu tienda preferida y compártela desde el día uno.",
    "¡Tu primer regalo va por nuestra cuenta!*",
    "Recibe los regalos que elegiste en casa o acumula su valor en monedero electrónico.",
    "Utiliza tu monedero electrónico para tu luna de miel.**",
    "Recibe notificaciones cada que te regalen algo y envía mensajes de agradecimiento.",
  ];

  componentDidMount() {
    this.setState({ isactiveItem: null, title: "Selecciona el tipo de mesa" });
    document.body.classList.add('body-no-scroll');
  }

  onItemClick = (item) => {
    this.setState({
      isactiveItem: item.id,
      title: `Beneficios - ${item.label}`,
      route: item.route,
    });
  };

  onBackBtnClick = () => {
    this.setState({ isactiveItem: null, title: "Selecciona el tipo de mesa" });
  };

  clearPersonalizationStateData = () => {
    const {
      setEventTxtValue,
      setEventDateValue,
      setSelectedImage1,
      setSelectedImage2,
      setEventComment,
      setSelectedThemeUid,
      setThemeData,
      clearEventData,
    } = this.props;

    setEventTxtValue("");
    setEventDateValue("");
    setSelectedImage1("");
    setSelectedImage2("");
    setEventComment("");
    setSelectedThemeUid("");
    setThemeData([]);
    clearEventData();
  };

  navigate = () => {
    this.clearPersonalizationStateData();
    browserHistory.push(this.state.route);
    this.props.hideModalOverlay();
    document.body.classList.remove('body-no-scroll');
  }

  render() {
    const { isactiveItem, title } = this.state;

    const { allowedEventTypes } = this.props;

    const availableEventTypes =
      allowedEventTypes?.data?.eventTypesInfo
        ?.filter((eventType) => eventType.available)
        ?.map((eventType) => eventType.eventType) || [];

    const initialJson = this.initialJson.giftList.items.filter((item, index) => {
      let action_disabled = true;
      if(availableEventTypes && availableEventTypes.length > 0){
        action_disabled = availableEventTypes?.indexOf(item?.eventType) < 0;
        item.disabled = action_disabled;
      }
      item.disabled = action_disabled
      return item;
    })
    

    return (
      <div id="create-table-modal-overlay" className="evnt_modal_overlay">
        <div className="modal-content-event createTableAdmin">
          <div className="evnt-modal-header">
            <h4 className="modal-title">{title}</h4>
            <button
              className="close-button"
              onClick={this.props.hideModalOverlay}
              aria-label="Cerrar modal"
            >
              <img
                src={commonUtil.getAssetURL() + "/images/close.svg"}
                alt=""
                className="icon_vozcliente"
              />
            </button>
          </div>
          <div className="evnt_modal_body" onClick={(e) => e.stopPropagation()}>
            <div className="row">
              {!isactiveItem ? (
                <div>
                  {initialJson.map((item, index) => {
                   const svgString = item.image.replace('<svg', '<svg fill="currentColor"');
                  return  (<div
                      className={`image-menu-item ${item.disabled ? 'disabled' : ''}`}
                      onClick={!item.disabled ? () => this.onItemClick(item) : undefined}
                      key={item.id}
                    >
                      <span
                        style={{ color: this.props.selectedTheme?.color_500 || "#333" }}
                        dangerouslySetInnerHTML={{ __html: svgString }}
                      />{" "}
                      <span className="image-menu-item-label">{item.name}</span>
                    </div>)
  })}
                </div>
              ) : (
                <div>
                  <div className="listDot createPopupGiftSpace">
                    <ul>
                      {this.mesaDeRegalos.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                    <div className="hra"> </div>
                  </div>

                  <div className="event_modal_sectionTwo">
                    <div>
                      *Acumula $1,000 pesos en regalos o compras personales.
                    </div>
                    <div>
                      ** Aplica únicamente en Viajes de El Corte Inglés.
                    </div>
                  </div>

                  <div className={`buttonBlock button-border-top ${channel == 'web' && 'button-bottom' }`} id="gift-list-contract-btn">
                    <div className={`col-xs-6 col-sm-6 col-lg-6 pl-0`}>
                      <div className="buttonBlock newButtonBlock">
                        <button
                            className="btnSecondaryAction size-Large btnSecondaryAction size-Full"
                            aria-hidden="false"
                            onClick={this.onBackBtnClick}
                            style={{
                              '--color-500': this.props.selectedTheme?.color_500 || "#333",
                              border: '1px solid var(--color-500)',
                              color: 'var(--color-500)',
                            }}
                        >
                            Regresar
                        </button>
                      </div>
                    </div>
                    <div className={`col-xs-6 col-sm-6 pr-0 col-lg-6`}>
                      <div className="buttonBlock newButtonBlock">
                          <button
                            className="btnPrimary size-Large size-Full"
                            aria-hidden="false"
                            onClick={this.navigate}
                            style={{
                              '--color-500': this.props.selectedTheme?.color_500 || "#333",
                            }}
                          >
                            Crear mesa
                          </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  lables: state.labels.data,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clearEventData,
      setSelectedImage1,
      setSelectedImage2,
      setEventTxtValue,
      setEventDateValue,
      setEventComment,
      setThemeData,
      setSelectedThemeUid,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(CreateTableModalOverlay);
